import React from 'react';
import { Formik } from 'formik';
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/client';
import {
  CREATE_CATEGORY,
  UPDATE_CATEGORY,
} from 'pages/Products/ProductsGraphQL';
import ErrorBoundary from 'components/common/ErrorBoundary';
import {
  categoryInitialValues,
  categoryValidationSchema,
  getCategoryInitialValues,
} from 'pages/Products/constant';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import AddEditCategoryForm from './components/AddEditCategoryForm';

const AddEditCategory = ({ toggleAddRecord, currentRow, type }) => {
  const [createCategory] = useMutation(CREATE_CATEGORY, {
    // eslint-disable-next-line no-shadow
    onCompleted: (data) => {
      toast.success(data?.createCategory);
      toggleAddRecord();
    },

    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ exception }) => {
        toast.error(exception?.message);
        return exception;
      });
    },
  });

  const [updateCategory] = useMutation(UPDATE_CATEGORY, {
    // eslint-disable-next-line no-shadow
    onCompleted: (data) => {
      toast.success(data?.updateCategory);
      toggleAddRecord();
    },

    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ exception }) => {
        toast.error(exception?.message);
        return exception;
      });
    },
  });

  const handleSubmit = async (values) => {
    if (type === ADD_EDIT_CONSTANT.EDIT) {
      try {
        await updateCategory({
          variables: {
            category: {
              ...values,
              photo: [values.photo],
              document: [values.document],
            },
          },
        });
      } catch (err) {
        toast.error(err);
      }
    } else {
      try {
        await createCategory({
          variables: {
            category: {
              ...values,
              photo: [values.photo],
              document: [values.document],
            },
          },
        });
      } catch (err) {
        toast.error(err);
      }
    }
  };
  return (
    <div>
      <ErrorBoundary>
        <Formik
          initialValues={
            type === ADD_EDIT_CONSTANT.EDIT
              ? getCategoryInitialValues(currentRow)
              : categoryInitialValues
          }
          enableReinitialize
          validationSchema={categoryValidationSchema}
          onSubmit={handleSubmit}
          children={(props) => {
            return (
              <AddEditCategoryForm
                toggleAddRecord={toggleAddRecord}
                {...props}
                type={type}
              />
            );
          }}
        />
      </ErrorBoundary>
    </div>
  );
};

export default AddEditCategory;
